import React from 'react';

import { SolarPlannerInteractive } from '@sunwisesoftware/pv-layout-core';
import { Box, Skeleton } from '@sunwisesoftware/sunwise-ui';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';

import {
    getNewSolarModules,
    getPolygonCoordinates,
} from 'common/utils/helpers';

import { getIsFetchingPvLayout, getPvLayoutData } from '../selectors';

// Alurack only uses panel_modules (new format), so getSolarModules (legacy)
// from Sunwise is not needed here.
const getSegmentsFormatted = (parentFieldSegment) =>
    (parentFieldSegment.field_segments ?? []).map(
        ({
            custom_inputs,
            field_segment_points,
            height,
            id,
            image,
            name,
            opacity,
            panel_modules,
            rotate,
            segment_color,
            segment_stroke_color,
            type,
            zindex,
        }) => ({
            custom_inputs,
            height,
            id,
            image,
            name,
            opacity,
            polygon: getPolygonCoordinates(field_segment_points),
            rotate,
            segment_color,
            segment_stroke_color,
            solar_modules: getNewSolarModules(panel_modules),
            type,
            zIndex: zindex,
        }),
    );

const PvLayoutViewer = () => {
    const isFetchingPvLayout = useSelector(getIsFetchingPvLayout);
    const pvLayoutData = useSelector(getPvLayoutData);

    const parentFieldSegment = get(
        pvLayoutData,
        `parent_field_segments[0]`,
        {},
    );

    if (isFetchingPvLayout) {
        return (
            <Box display="flex" justifyContent="center" mt={2} px={2}>
                <Skeleton variant="rectangular" />
            </Box>
        );
    }

    if (isEmpty(parentFieldSegment)) return null;

    const location = {
        latitude: +get(parentFieldSegment, 'latitude', 21.03337604613389),
        longitude: +get(parentFieldSegment, 'longitude', -89.62693562626953),
    };

    const segments = getSegmentsFormatted(parentFieldSegment);

    return (
        <SolarPlannerInteractive
            googleApiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}
            isAlurack={true}
            locale="es"
            location={location}
            segments={segments}
            viewMode="3d"
        />
    );
};

PvLayoutViewer.propTypes = {};

export default PvLayoutViewer;
